module.exports = __webpack_public_path__ + "img/icon-xiaohongshu.feac4550.png";